import { RecordType } from '@xbcb/shared-types';

// EU customs entries whose task lifecycle is system-driven; the manual
// start/stop task buttons stay hidden for them (see CR-176792121).
const customsEntryRecordTypes: RecordType[] = [
  RecordType.GB_CUSTOMS_ENTRY,
  RecordType.DE_CUSTOMS_ENTRY,
  RecordType.NL_CUSTOMS_ENTRY,
  RecordType.FR_CUSTOMS_ENTRY,
];

// Whether the start/stop (Open Task / Pause Task) buttons should be hidden for
// a record. Customs entries are always hidden. CuDe re-enables them for time
// tracking, but only in CuDe-editable stages (behind the CI visibility flag),
// mirroring the draft-edit-mode gating; elsewhere the buttons show as before.
export const isStartStopTaskButtonHidden = ({
  recordType,
  isCuDeEditableStage,
}: {
  recordType?: RecordType | null;
  isCuDeEditableStage: boolean;
}): boolean => {
  if (!recordType) return false;
  if (customsEntryRecordTypes.includes(recordType)) return true;
  if (recordType === RecordType.CUSTOMS_DECLARATION) {
    return !isCuDeEditableStage;
  }
  return false;
};
